import { select } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import { useSelector } from 'react-redux';

import { TXTWCL_HelloX_how_can_we_helpX, TXTWCL_Hello_N0X_how_can_we_helpX } from '../translations';

// TODO: add the lint-styles target to the lib once we migrate any .scss files

const Welcome: React.FC = () => {
  const userId = useSelector(select.account.getUserId);
  const isAuthenticated = useSelector(select.session.isAuthenticated);

  return isAuthenticated ? (
    <Translation tagName="h2" values={{ 0: userId }} {...TXTWCL_Hello_N0X_how_can_we_helpX} />
  ) : (
    <Translation tagName="h2" {...TXTWCL_HelloX_how_can_we_helpX} />
  );
};

export default Welcome;
